/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Deliver_Desc7Inputs */

const en_svc_automation_deliver_desc7 = /** @type {(inputs: Svc_Automation_Deliver_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move data between platforms and deliver outputs where your team actually looks, Slack, email, storage, or a dashboard.`)
};

const ar_svc_automation_deliver_desc7 = /** @type {(inputs: Svc_Automation_Deliver_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انقل البيانات بين المنصات وسلّم المخرجات حيث ينظر فريقك فعلًا, سلاك أو البريد أو التخزين أو لوحة تحكم.`)
};

const bn_svc_automation_deliver_desc7 = /** @type {(inputs: Svc_Automation_Deliver_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্ল্যাটফর্মের মধ্যে ডেটা সরান এবং আউটপুট পৌঁছান যেখানে আপনার টিম আসলে দেখে, Slack, ইমেইল, স্টোরেজ বা ড্যাশবোর্ড।`)
};

const de_svc_automation_deliver_desc7 = /** @type {(inputs: Svc_Automation_Deliver_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschieben Sie Daten zwischen Plattformen und liefern Sie Ergebnisse dort, wo Ihr Team tatsächlich hinschaut: Slack, E-Mail, Speicher oder ein Dashboard.`)
};

const es_svc_automation_deliver_desc7 = /** @type {(inputs: Svc_Automation_Deliver_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mueva datos entre plataformas y entregue resultados donde su equipo realmente mira: Slack, correo electrónico, almacenamiento o un panel.`)
};

const fr_svc_automation_deliver_desc7 = /** @type {(inputs: Svc_Automation_Deliver_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déplacez les données entre les plateformes et fournissez des résultats là où votre équipe les consulte réellement : Slack, e-mail, stockage ou tableau de bord.`)
};

const pt_svc_automation_deliver_desc7 = /** @type {(inputs: Svc_Automation_Deliver_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mova dados entre plataformas e entregue resultados onde sua equipe realmente olha, Slack, e-mail, armazenamento ou um painel.`)
};

const zh_svc_automation_deliver_desc7 = /** @type {(inputs: Svc_Automation_Deliver_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在平台之间移动数据并在您的团队实际查看的地方（Slack、电子邮件、存储或看板）提供输出。`)
};

const tr_svc_automation_deliver_desc7 = /** @type {(inputs: Svc_Automation_Deliver_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verileri platformlar arasında taşıyıp çıktıları ekibinizin gerçekten kullandığı yerlere göndeririz: Slack, e-posta, depolama veya pano.`)
};

const ru_svc_automation_deliver_desc7 = /** @type {(inputs: Svc_Automation_Deliver_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перемещайте данные между платформами и предоставляйте результаты там, где на самом деле ищет ваша команда: Slack, электронная почта, хранилище или панель мониторинга.`)
};

const pl_svc_automation_deliver_desc7 = /** @type {(inputs: Svc_Automation_Deliver_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przenoś dane między platformami i dostarczaj wyniki tam, gdzie faktycznie patrzy Twój zespół – Slack, poczta e-mail, pamięć masowa lub pulpit nawigacyjny.`)
};

/**
* | output |
* | --- |
* | "Move data between platforms and deliver outputs where your team actually looks, Slack, email, storage, or a dashboard." |
*
* @param {Svc_Automation_Deliver_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_deliver_desc7 = /** @type {((inputs?: Svc_Automation_Deliver_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Deliver_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_deliver_desc7(inputs)
	if (locale === "bn") return bn_svc_automation_deliver_desc7(inputs)
	if (locale === "de") return de_svc_automation_deliver_desc7(inputs)
	if (locale === "es") return es_svc_automation_deliver_desc7(inputs)
	if (locale === "fr") return fr_svc_automation_deliver_desc7(inputs)
	if (locale === "pt") return pt_svc_automation_deliver_desc7(inputs)
	if (locale === "zh") return zh_svc_automation_deliver_desc7(inputs)
	if (locale === "tr") return tr_svc_automation_deliver_desc7(inputs)
	if (locale === "ru") return ru_svc_automation_deliver_desc7(inputs)
	if (locale === "pl") return pl_svc_automation_deliver_desc7(inputs)
	return en_svc_automation_deliver_desc7(inputs)
});
export { svc_automation_deliver_desc7 as "svc_automation_DELIVER_desc" }